import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Ausschreibung} from '../model/ausschreibung';
import {AusschreibungService} from '../service/ausschreibung.service';

@Injectable({
  providedIn: 'root',
})
export class AusschreibungResolver {
  constructor(private ausschreibungService: AusschreibungService, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Ausschreibung> {
    const id = route.paramMap.get('id');

    if (!id || id === 'undefined') {
      this.router.navigate(['']);
    }

    return this.ausschreibungService.find(id ?? '');
  }
}
